import script from "./GlobalSearchDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSearchDialog.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSearchDialog.vue?vue&type=style&index=0&id=f2439304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2439304"]])

export default __exports__